<template>
  <div class="cont">
    <div class="row m-0">
      <div class="col-md-12 left-nav p-0">
        <ul>
          <router-link tag="li" :to="{ name: 'educational-info-setup' }"><span>A</span>Educational Info</router-link>
          <router-link tag="li" :to="{ name: 'teaching-info-setup' }" :class="{disabled: !u.progress.education }"><span>B</span>Teaching Info</router-link>
          <router-link  tag="li" :to="{ name: 'work-experience-setup' }"  :class="{disabled: !u.progress.teaching }"><span>C</span>Work Experience</router-link>
        </ul>
      </div>
      <div class="col-12 p-0">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileEducation from '@/components/Pages/Profile/EditEducation';
import ProfileTeaching from '@/components/Pages/Profile/EditTeaching';
import ProfileWork from '@/components/Pages/Profile/EditWork';
import momentzone from 'moment-timezone';
import swal from 'sweetalert';
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'education-setup',
  components: {
    ProfileEducation,
    ProfileTeaching,
    ProfileWork,
  },
  computed: {
    u() {
      return this.$auth.user();
    },
  },
  methods: {
    saveAndContinue() {
      if (!this.u.progress.education) {
        return swal('Please complete the Education info setup');
      }
      if (!this.u.progress.teaching) {
        return swal('Please complete the teaching experience setup');
      }
      if (!this.u.progress.work) {
        return swal('Please complete the Work experience setup');
      }
      axios.post(`${BASE_API}/v1/tutor/steps`, { step: 'educational_background' })
        .then(() => this.$store.dispatch('getUserTutor'));
      return this.$router.push({ name: 'verification-setup' });
    },
    ac(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => this.$route.path.indexOf(path) >= 0);
    },
  },
  mounted() {
    if (this.$auth.user().verified) {
      const notification = {
        id: Math.floor((Math.random() * 100000) + 1),
        read: false,
        type: 'warn',
        content: `Please note that if you make any edits you'll be unverified and you'll have to wait for re-verification.`,
        flag: 're-edit-warn',
        created_at: {
          date: moment().format('YYYY-MM-DD HH:mm:ss'),
          timezone: momentzone.tz.guess(),
          timezone_type: 3,
        },
        created_by: 'SYSTEM',
      };
      this.$emit('notify', notification);
    }
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.cont {
  padding: 15px 0;
}
h3.title {
  font-size: 20px;
  font-weight: 800;
  margin: 10px 0;
}
p.subtitle {
  margin: 5px 0;
  color: #2A2A2A;
  font-size: 16px;
}
.submit-button {
  width: 130px;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  vertical-align: middle;
  float: right;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14), 0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
  &.btn-default {
    box-shadow: 0 2px 2px 0 rgba(112, 112, 112, 0.14), 0 3px 1px -2px rgba(112, 112, 112, 0.12), 0 1px 5px 0 rgba(112, 112, 112, 0.2);
  }
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {box-shadow: none !important;}
  }
}
.mx { margin: 0 10px; }
.foot {
  margin-top: 30px;
}
.left-nav {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  ul {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1220px;
    position: relative;
    padding: 0;
    &::before {
      content: ' ';
      position: absolute;
      height: 1px;
      width: calc(100% - 40px);
      display: block;
      top: 50%;
      left: 40px;
      background-color: rgba(0, 0, 0, .25);
      z-index: 0;
    }
    li {
      background-color: #fcfcfc;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      z-index: 2;
       &.disabled {
        opacity: 1 !important;
        color: rgba(33, 37, 41, 0.6);
        span {opacity: 0.3;}
      }
      span {
        width: 50px;
        height: 50px;
        background-color: #F0F2F8;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        padding: 10px 0;
        margin: 10px 0;
        cursor: pointer;
      }
      &:hover{color: #639440;}
      &.active {list-style-image: url(../../../assets/tick.svg); color: #639440; span {background-color: #639440; color: #fff}}
    }
  }
  h1 {width: 100%;}
  p {width: 100%;}
}
@media only screen and (max-width: 600px) {
  .cont {padding: 0;}
  .left-nav {
    padding: 5px;
    ul {
      margin-bottom: 0;
      li {padding: 5px; font-size: 11px; span {
        height: 30px;
        width: 30px;
        background-color: #838383;
        color: #fff;
      }}
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Setup/Education.vue